// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2W8XR","slick-next":"CustomSlider_slick-next__2D9ku"};